import { render, staticRenderFns } from "./PositionLocations.vue?vue&type=template&id=158a4f45"
import script from "./PositionLocations.vue?vue&type=script&lang=js"
export * from "./PositionLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports